module.exports = __webpack_public_path__ + "img/qostanay1.65ba5f70.jpg";